import React from 'react';
import ChecklistCategory from './checklistCategory.component';
import { IStepCategory } from '@app/models';

interface IProps {
    steps: IStepCategory[];
}

const Checklist: React.SFC<IProps> = ({ steps }) => {
    const categories = steps.map((category: IStepCategory, index: number)  => <ChecklistCategory category={category} key={index} />);

    return (
        <>
            {categories}
        </>
    );


};

export default Checklist;
